import "./HomeEn.module.css";
import MainNavigation from "@/reusable_sections/Header";
import EngineeringPrecisionForIndustrialProgress from "./sections/EngineeringPrecisionForIndustrialProgress";
import OurPlumbingSpecialties from "./sections/OurPlumbingSpecialties";
import SectorExpertise from "./sections/SectorExpertise";
import HeritageHospitality from "./sections/HeritageHospitality";
import GlobalImpact from "./sections/GlobalImpact";
import TienesUnEvento from "./sections/TienesUnEvento";
import IndustrySolutionsZLayout from "./sections/IndustrySolutionsZLayout";
import ContactRequest from "./sections/ContactRequest";
import Footer from "@/reusable_sections/Footer";
export default function HomeEnPage() {
  return <div>
      <MainNavigation />
      <EngineeringPrecisionForIndustrialProgress />
      <OurPlumbingSpecialties />
      <SectorExpertise />
      <HeritageHospitality />
      <GlobalImpact />
      <TienesUnEvento />
      <IndustrySolutionsZLayout />
      <ContactRequest />
      <Footer />
    </div>;
}